import React, { useEffect, useState } from "react";
import Nav from "../components/nav";
import useFetch from "../utils/useFetch";
import { useParams } from "react-router-dom";
import { API_URL } from "../utils/constants";
import Loader from "../components/loader";

const CaseStudy = () => {
  const { id } = useParams();
  const { data: projects, error } = useFetch(`${API_URL}`);
  const [caseStudy, setCaseStudy] = useState(projects);

  // for overlay
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);

  const handleLinkClick = () => {
    setIsOverlayOpen(true);
  };

  const handleCloseOverlay = () => {
    setIsOverlayOpen(false);
  };
  // for overlay
  useEffect(() => {
    setCaseStudy(projects?.filter((project) => project.id.includes(id)));
  }, [projects, id]);
  // console.log(caseStudy[0].tag.length);
  return (
    <>
      <Nav />
      <section className="max-w-screen-2xl md:px-10 px-5 mx-auto pt-[100px] pb-2">
        {caseStudy ? (
          <>
            <div className="mb-20 md:grid md:grid-cols-2 gap-4">
              <div>
                <h5 className="pt-5">
                  {caseStudy[0].tag.map((tag, index) => (
                    <span className="subH" key={index}>
                      {tag}
                      {index < caseStudy[0].tag.length - 1 ? " | " : ""}
                    </span>
                  ))}
                </h5>
                <h1 className="text-3xl">{caseStudy[0].title}</h1>
                <h5 className="subH pt-5">My role</h5>
                <h4>
                  {caseStudy[0].role.map((role, index) => (
                    <p key={index}>{role}</p>
                  ))}
                </h4>
                <h5 className="subH pt-5">Client</h5>
                {/* link  */}
                {caseStudy[0].link !== "" && caseStudy[0].embed === false ? (
                  <a
                    href={caseStudy[0].link}
                    target="_blank"
                    rel="noreferrer"
                    className={`font-semibold link cursor-pointer`}
                  >
                    {caseStudy[0].client}
                  </a>
                ) : caseStudy[0].link !== "" && caseStudy[0].embed === true ? (
                  // for embed
                  <div
                    onClick={handleLinkClick}
                    className={`font-semibold link cursor-pointer`}
                  >
                    {caseStudy[0].client}
                  </div>
                ) : (
                  <div className={`font-semibold`}>{caseStudy[0].client}</div>
                )}
                <h5 className="subH pt-5">Year</h5>
                <h4>{caseStudy[0].year}</h4>
              </div>
              <p className="pt-14 whitespace-pre-wrap	">{caseStudy[0].desc} </p>
            </div>
            {caseStudy[0].gallery[0] && (
              <div className="images">
                {caseStudy[0].gallery.map((item, index) => (
                  <img
                    src={require(
                      `../assets/images/mockups/${caseStudy[0].id}/${item}`,
                    )}
                    alt={item}
                    key={index}
                    className="mb-7 border border-neutral-300 rounded w-full "
                  />
                ))}
              </div>
            )}
          </>
        ) : error ? (
          <p>{error}</p>
        ) : (
          <Loader />
        )}
      </section>
      {isOverlayOpen && (
        <div className="fixed inset-0 flex justify-center items-center z-[100000] w-screen bg-gray-900/60">
          <button
            className="absolute top-5 right-12 text-white text-5xl flex items-center bg-gray-900 hover:bg-gray-600 transition duration-300 rounded-full px-5 justify-center"
            onClick={handleCloseOverlay}
          >
            &times; <span className="md:text-lg text-sm text-white">CLOSE</span>
          </button>
          <iframe
            className="md:h-[90dvh] md:w-[90dvw] h-[80dvh] w-[90dvw] border-0 rounded"
            title="embed figma"
            src={caseStudy[0].link}
            allowFullScreen
          ></iframe>
        </div>
      )}
    </>
  );
};

export default CaseStudy;
